import { startNumberAmerican } from "../constants"
import i18n from "../i18n"

/**
 * Retorna o comprimento esperado do CVV com base na bandeira do cartão.
 * American Express usa 4 dígitos (CVE2); demais bandeiras usam 3.
 */
export function getCvvLength(cardNumber?: string): 3 | 4 {
  if (!cardNumber) return 3
  const digitsOnly = cardNumber.replace(/\D/g, "")
  const isAmex = startNumberAmerican.some((prefix) =>
    digitsOnly.startsWith(prefix),
  )
  return isAmex ? 4 : 3
}

/**
 * Valida o CVV do cartão. Retorna `true` se válido ou a mensagem de erro no idioma do checkout.
 */
export function validateCvv(
  cvv?: string,
  cardNumber?: string,
): boolean | string {
  if (!cvv || cvv.trim() === "") {
    return i18n.t("errors.cvvRequired")
  }

  if (!/^\d+$/.test(cvv)) {
    return i18n.t("errors.cvvDigitsOnly")
  }

  const expectedLength = getCvvLength(cardNumber)

  if (cvv.length < expectedLength) {
    return i18n.t("errors.cvvLength", { length: expectedLength })
  }

  if (cvv.length > 4) {
    return i18n.t("errors.cvvMaxLength")
  }

  return true
}

/**
 * Transform para TextFieldRequired: remove caracteres não-numéricos do CVV.
 */
export function cvvDigitsOnly(value: string): string {
  return value.replace(/\D/g, "")
}
